import { Box, Card, Stack, Typography } from "@mui/material";
import Logo from "src/components/logo";

export default function Page() {
  return <Box p={4} display="flex" justifyContent="center">
    <Card sx={{ p: 4, maxWidth: "800px" }}>
      <Stack gap={2}>
        <Logo sx={{ marginBottom: 4, marginTop: 2 }} />
        <Typography variant="h3" component="h1" textAlign="center">Your account has no access to any Organizations.</Typography>
        <Typography component="p" textAlign="center">Please reach out to your account administrator so that they can Activate your account.</Typography>
        <Typography component="p" textAlign="center">If you believe this is our mistake reach out <a href="mailto:support@countingtrucks.com">support@countingtrucks.com</a></Typography>
      </Stack>
    </Card>
  </Box>
}
